import {FACTIONS} from "../../../constants/factions";

export const GOBLINS_QUOTES = [{
  quote: 'Ворота? У них нет ворот. У них есть куча щепок, которая ждёт нашей спички',
  author: 'Зубодер Клямс, прославленный разрушитель крепостей',
  factionId: FACTIONS.GOBLINS
}, {
  quote: 'Ловушка, которую враг заметил, — плохая ловушка. Ловушка, которую он обезвредил, — последняя в его жизни',
  author: 'Клок Дырявый, гоблин-старшина диверсантов клана Скрипучих петлей',
  factionId: FACTIONS.GOBLINS
}, {
  quote: 'Стены падают не от тарана. Стены падают от того, что под ними нет земли',
  author: 'Мох Кислотная, гоблин-выжигательница петель',
  factionId: FACTIONS.GOBLINS
}, {
  quote: 'Не нужно штурмовать ворота. Нужно, чтобы ворота сами упали. И лучше на голову тому, кто их запирал',
  author: 'Стук Палый, гоблин-мастер ложных обвалов',
  factionId: FACTIONS.GOBLINS
}, {
  quote: 'Наши ловушки — цветы, которые они топчут. Но мы не обижаемся',
  author: 'Хрип Бьюз, гоблин, гоблин-мастер рвущихся конечностей',
  factionId: FACTIONS.GOBLINS
}, {
  quote: 'Чем сложнее замок, тем громче он открывается',
  author: 'Чир Масляный, гоблин-смотритель Голосистого логова',
  factionId: FACTIONS.GOBLINS
}]